// Original code from Seunghyun Kim
//https://medium.com/@shkim04/react-how-to-detect-click-outside-a-component-984fe2e003e8

import { useRef, useEffect } from 'react';

export default function ClickOutside({ children, exceptionRef, onClick, className,
  mobileContainer, explodedContainer
}) {
  const wrapperRef = useRef();

  useEffect(() => {
    document.addEventListener('mousedown', handleClickListener);

    return () => {
      document.removeEventListener('mousedown', handleClickListener);
    };
  }, []);

  const handleClickListener = (event) => {
    let clickedInside;
    if(exceptionRef) {
      clickedInside = (wrapperRef && wrapperRef.current.contains(event.target)) || exceptionRef.current === event.target || exceptionRef.current.contains(event.target);
    }
    else {
      clickedInside = (wrapperRef && wrapperRef.current.contains(event.target));
    }

    if (clickedInside || event.target.id === 'sub-link') return;
    // if((!explodedContainer || !explodedContainer.contains(event.target)) ||
    //   mobileContainer && !mobileContainer.contains(event.target)
    // ) onClick();
    onClick();
  }

  return (
    <div ref={wrapperRef} className={`${className || ''}`}>
      {children}
    </div>
  );
};